import { useState } from "react";
import {
  TableCell,
  TableRow,
  Typography,
  IconButton,
  Tooltip,
} from "@pankod/refine-mui";
import {
  bbStyle,
  bb1Style,
  bb2Style,
  bb3Style,
  btStyle,
  bt1Style,
  bt2Style,
  bt3Style,
} from "./BorderStyles";

import InputCellCoupon from "./InputCellCoupon";
import CheckboxCoupon from "./CheckboxCoupon";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export default function CouponRow({ row, firstDay, couponID, loading }) {
  const [open, setOpen] = useState(false);
  //& > *: This selector targets all direct children (> *) of the current element (&).
  //In this case, it selects all the immediate children of the TableRow.
  //"& > *": { borderBottom: "unset" },

  return (
    <>
      <TableRow
        sx={open ? { "& td": { borderBottom: "unset" } } : { "& td": bb3Style }}
      >
        <TableCell style={{ minWidth: 120 }}>
          <Typography variant="subtitle1">{row.accommodationName}</Typography>
        </TableCell>
        <TableCell />
        <TableCell>
          <IconButton
            aria-label="expand accommodation"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {row.remaining.map((item, index) => {
          var date = new Date(firstDay);
          date.setDate(firstDay.getDate() + index);
          if (date >= row.start && date < row.end) {
            return (
              <TableCell key={index} align="center">
                <Tooltip
                  title={`${item}/${row.quantity[index]}. ${
                    row.quantity[index] - item
                  } prenotazioni`}
                  arrow
                  PopperProps={{
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, -14],
                        },
                      },
                    ],
                  }}
                >
                  <div>
                    <InputCellCoupon
                      value={loading ? null : item}
                      accommodationID={row.accommodationID}
                      couponID={couponID}
                      field="quantity"
                      fromDate={date}
                      toDate={date}
                    />
                  </div>
                </Tooltip>
              </TableCell>
            );
          } else return <TableCell key={index} />;
        })}
      </TableRow>

      {open && (
        <>
          <TableRow sx={{ "& td": { borderBottom: "unset" } }}>
            <TableCell style={{ minWidth: 120 }} />
            <TableCell>
              <Typography variant="caption">BB</Typography>
            </TableCell>
            <TableCell />
            {row.BB.map((item, index) => {
              var date = new Date(firstDay);
              date.setDate(firstDay.getDate() + index);
              if (date >= row.start && date < row.end) {
                return (
                  <TableCell key={index} align="center">
                    <CheckboxCoupon
                      value={loading ? false : item}
                      accommodationID={row.accommodationID}
                      couponID={couponID}
                      field="BB"
                      fromDate={date}
                      toDate={date}
                      disabled
                    />
                  </TableCell>
                );
              } else return <TableCell key={index} />;
            })}
          </TableRow>

          <TableRow sx={{ "& td": { borderBottom: "unset" } }}>
            <TableCell style={{ minWidth: 120 }} />
            <TableCell>
              <Typography variant="caption">HB</Typography>
            </TableCell>
            <TableCell />
            {row.HB.map((item, index) => {
              var date = new Date(firstDay);
              date.setDate(firstDay.getDate() + index);
              if (date >= row.start && date < row.end) {
                return (
                  <TableCell key={index} align="center">
                    <CheckboxCoupon
                      value={loading ? null : item}
                      accommodationID={row.accommodationID}
                      couponID={couponID}
                      field="HB"
                      fromDate={date}
                      toDate={date}
                    />
                  </TableCell>
                );
              } else return <TableCell key={index} />;
            })}
          </TableRow>

          <TableRow sx={{ "& td": bb3Style }}>
            <TableCell style={{ minWidth: 120 }} />
            <TableCell>
              <Typography variant="caption">FB</Typography>
            </TableCell>
            <TableCell />
            {row.FB.map((item, index) => {
              var date = new Date(firstDay);
              date.setDate(firstDay.getDate() + index);
              if (date >= row.start && date < row.end) {
                return (
                  <TableCell key={index} align="center">
                    <CheckboxCoupon
                      value={loading ? null : item}
                      accommodationID={row.accommodationID}
                      couponID={couponID}
                      field="FB"
                      fromDate={date}
                      toDate={date}
                    />
                  </TableCell>
                );
              } else return <TableCell key={index} />;
            })}
          </TableRow>
        </>
      )}
    </>
  );
}
